import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const AnalyticsModule = lazy(loadModule);

export default AnalyticsModule;
